import { Tool } from "../context/AppContext";
import { Chat } from "../hooks/useChats";

export enum MessageType {
    text = 'text',
    image = 'image',
    file = 'file'
  }

export type MessageSendPayload = {
    senderId: string;
    content: string;
    type: MessageType;
    chatId?: string;
    to?: string;
    tool?: Tool;
}
export type MessageReceivePayload = {
    chat: Chat;
    senderId: string;
    senderName: string;
    content: string;
    type: MessageType;
    timestamp: Date;
    to?: string;
    recipientSocketId?: string;
    createdAt: Date;
    tool?: Tool;
}
